import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { useContent } from "../lib/useContent";
import { useSeo, Reveal, Icon } from "../components/common";
import { PageHero } from "../components/PageHero";
import { CTABand } from "../components/blocks";
import { StarRow } from "../components/cards";
import { IMG } from "../data/site";

export default function Reviews() {
  const { t } = useLang();
  useSeo("Reviews | Sparko Cleaning Netherlands", "Read five-star reviews from Sparko clients across the Netherlands — offices, hotels, restaurants and more.");
  const { data: reviews } = useContent("reviews");

  return (
    <div>
      <PageHero title="Client Reviews" crumb={t.nav.reviews} bg={IMG.office3}
        sub="Trusted and rated five stars by businesses and homeowners across the Netherlands." />

      <section className="mx-auto max-w-7xl px-5 md:px-8 py-24 pt-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <Reveal key={r.id} delay={(i % 3) * 0.08}>
              <div className="h-full rounded-3xl bg-white p-8 border border-black/5 hover-lift" data-testid="review-card">
                <div className="flex items-center justify-between">
                  <StarRow n={r.rating || 5} />
                  <Icon name="Quote" size={28} className="text-blue/20" />
                </div>
                <p className="mt-5 text-navy leading-relaxed">“{r.text}”</p>
                <div className="mt-6 flex items-center gap-3">
                  <div className="grid place-items-center h-11 w-11 rounded-full bg-navy text-white font-display">{r.name.charAt(0)}</div>
                  <div>
                    <div className="font-semibold text-navy">{r.name}</div>
                    <div className="text-sm text-slate-500">{r.role}</div>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <CTABand />
    </div>
  );
}
